import moment from 'moment';
import { head } from 'lodash';

class PremierDashboardController {
    constructor(access, authService, dataApiService, reportsService, messageService, loadingService) {
        this.access = access;
        this.userData = authService.getProfile();
        this.dataApiService = dataApiService;
        this.reportsService = reportsService;
        this.messageService = messageService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.currentMoment = moment();

        this.loading = [];
        this.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.years = [];
        for (let index = 2019; index <= this.currentMoment.format('YYYY'); index++) {
            this.years.push(index);
        }
        this.years = this.years.reverse();

        this.year = `${this.years[0]}`;
        this.month = this.setLastMonth();

        this.getReportData();
    }

    setLastMonth () {
        let previousMonth = this.currentMoment.format('M') - 2;
        if (previousMonth < 0) {
            previousMonth = 12 + previousMonth;
            this.year = `${this.years[1]}`;
        }
        return `${previousMonth}`;
    }

    welcome () {
        let string = 'Good morning';
        let hour = this.currentMoment.hour();
        if (hour >= 12) {
            string = 'Good afternoon';
        }
        if (hour >= 18) {
            string = 'Good evening';
        }
        string += `, ${this.userData.nickname[0].toUpperCase()}${this.userData.nickname.substring(1)}`;

        return string;
    }

    getReportData () {
        if (this.isDataLoading()) {
            return;
        }

        if (this.access.check('premier_admin')) {
            return this.getPremierData();
        }
    }

    isDataLoading () {
        return this.loadingService.isLoading();
    }

    setDates () {
        let date = moment(`${this.year}-${parseInt(this.month, 10) + 1}-01`, 'YYYY-M-DD');

        this.dateFrom = date.format('YYYY-MM-DD');
        this.dateTo = date.add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD');
    }

    getPremierData () {
        this.loadingService.startLoading(['premierStatistics', 'premierInvoiced', 'properties', 'contracts']);

        return Promise.all([
            this.dataApiService.getIntegrationData('premier_statistics').then(response => {
                this.premierStatistics = response;
                this.loadingService.stopLoading('premierStatistics');
            }),
            this.dataApiService.getIntegrationData('invoiced_amounts').then(response => {
                this.premierInvoiced = response;
                this.loadingService.stopLoading('premierInvoiced');
            }),
            this.dataApiService.getIntegrationData('properties').then(response => {
                this.properties = this.setStatuses(response);
                this.loadingService.stopLoading('properties');
            }),
            this.dataApiService.getIntegrationData('contracts').then(response => {
                this.contracts = response;
                if (this.contracts.length){
                    this.contractsDate = this.formatDate(head(this.contracts).created_at);
                }
                this.loadingService.stopLoading('contracts');
            })
        ]);
    }

    generateIntegrationReport () {
        this.generating = true;

        if (this.hasReportFields()) {
            this.setDates();

            return this.reportsService.generateIntegration({
                'datefrom': this.dateFrom,
                'dateto': this.dateTo,
            }).then(response => {
                this.download = response.link;
                this.filename = response.name;
            }).catch(() => {
                this.messageService.failure('Unfortunately that report could not be generated, please try again.');
                this.messageService.push();
                this.messageService.autoClear();
            }).then(() => {
                this.generating = false;
            });
        }

        this.generating = false;
    }

    hasReportFields () {
        return !!this.month && !!this.year;
    }

    setStatuses (properties) {
        properties.forEach(property => {
            this.setStatus(property);
        });
        return properties;
    }

    setStatus (account) {
        if (account.go_live) {
            account.status = 'Integration Live';
            account.slug = 'live';
            return;
        }

        if (account.expected_go_live) {
            account.status = 'Awaiting Client Sign-off';
            account.slug = 'client-sign-off';
            return;
        }

        if (account.import_run) {
            account.status = 'Setup in Progress';
            account.slug = 'setup';
            return;
        }

        if (account.integration_created) {
            account.status = 'API Keys Supplied';
            account.slug = 'keys-supplied';
            return;
        }

        account.status = 'Awaiting API Keys';
        account.slug = 'awaiting-keys';
    }

    formatDate (date) {
        if (date) {
            return moment(date, 'YYYY-MM-DD').format('Do MMMM, YYYY');
        }

        return '-';
    }

    filterProperties () {
        this.hiddenCount = 0;

        this.properties.forEach(property => {
            property.hidden = false;
            if (!this.propertyFilter) {
                return;
            }

            if (this.propertyFilter !== property.slug) {
                ++this.hiddenCount;
                property.hidden = true;
            }
        });
    }

    clearFilter () {
        this.propertyFilter = null;
        this.filterProperties();
    }
}
PremierDashboardController.$inject = ['access', 'authService', 'dataApiService', 'reportsService', 'messageService', 'loadingService'];

export default PremierDashboardController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/controllers/premier.dashboard.controller.js